import { SVGProps } from 'react';

const ConsumerListingIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="18" width="18" fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="9" cy="9" r="8.5" stroke="white" />
      <path d="M8.99752 8.86154C10.1589 8.86154 11.1003 7.88517 11.1003 6.68077C11.1003 5.47636 10.1589 4.5 8.99752 4.5C7.83618 4.5 6.89474 5.47636 6.89474 6.68077C6.89474 7.88517 7.83618 8.86154 8.99752 8.86154Z" />
      <path d="M12.5999 12.0968V12.9882C12.5999 13.2713 12.3734 13.5 12.1004 13.5H5.89341C5.62043 13.5 5.3999 13.2713 5.3999 12.9882V12.0968C5.3999 10.7234 6.47394 9.60577 7.79831 9.60577H10.1967C10.7427 9.60577 11.2481 9.79615 11.6522 10.1151C12.2256 10.5701 12.5999 11.2883 12.5999 12.0968Z" />
    </svg>
  );
};

export default ConsumerListingIcon;
